import nfSaidaTotalTributos from "./calcular-tributos-nf-saida";

class NfSaidaItemImpostos {
  constructor(imposto, item, nfSaida) {
    this.calculaIcms =
      nfSaida?.documentoDevolucaoFornecedor || imposto?.calculaIcms;
    this.calculaIcmsSt =
      nfSaida?.documentoDevolucaoFornecedor || imposto?.calculaIcmsSt;
    this.modeloTributacaoId = imposto.modeloTributacaoId;
    this.tributosIcmsOrigem = item.tributosIcmsOrigem;
    this.tributosIcmsCsosn = imposto.csoSimplesNacional;
    this.tributosIcmsCst = imposto.codigoCst;
    this.cfop = imposto.cfop?.codigo;
    this.tributosIcmsBaseCalculoPercentualReducao = imposto?.reducaoBase;
    this.tributosIcmsBaseCalculoValor = imposto?.reducaoBase
      ? item?.subtotal - item?.subtotal * (imposto?.reducaoBase / 100)
      : item?.subtotal;
    this.tributosIcmsAliquota =
      item?.tributosIcmsAliquota || imposto?.aliquotaIcms;
    this.tributosIcmsValor = nfSaidaTotalTributos.calculaValorIcms({
      ...item,
      ...imposto,
      aliquotaIcms: item?.tributosIcmsAliquota || imposto?.aliquotaIcms,
    });
    this.aliquotaIcmsCredito = imposto?.aliquotaIcmsCredito;
    this.aliquotaIcmsDebito = imposto?.aliquotaIcmsDebito;
    this.aliquotaMva = item?.aliquotaMva || imposto?.aliquotaMva;
    this.impostoIcmsStAliquota = imposto?.aliquotaSt;
    this.impostoIcmsStReducao = imposto?.reducaoBaseSt;
    this.tributosIpiCst = imposto?.situacaoTributariaIpiId;
    this.tributosIpiEnquadramento = imposto?.enquadramentoLegalId;
    this.tributosIpiBaseCalculoValor = item?.subtotal;
    this.tributosIpiAliquota = item?.tributosIpiAliquota || imposto.aliquotaIpi;
    this.tributosIpiValor =
      item?.subtotal * ((imposto?.aliquotaIpi || 0) / 100);
    this.tributosIbsCst = imposto?.ibs?.codigo;
    this.tributosIbsClassificacao = imposto?.ibs?.codigoClassificacao;
    this.tributosIbsAliquotaUf = imposto?.aliquotaIbsUf;
    this.tributosIbsAliquotaMun = imposto?.aliquotaIbsMun;
    this.tributosIbsAliquotaCbs = imposto?.aliquotaCbs;
    this.tributosIbsAliquotaRedUf = imposto?.aliquotaIbsUfRed;
    this.tributosIbsAliquotaRedMun = imposto?.aliquotaIbsMunRed;
    this.tributosIbsAliquotaRedCbs = imposto?.aliquotaCbsRed;
  }
}

export default NfSaidaItemImpostos;
